import {
  type D2CSiteBusinessProfile,
  type D2CSiteContactProfile,
  type D2CSiteImageList,
} from '@orcar/common';

// 회사가 ERP 자사몰관리 > 사이트 내용에서 고치는 값. 서버에 처음 넣은 값과 같고,
// 내용 API 응답 전이나 실패했을 때만 쓴다. 바꿀 때는 ERP에서 게시한다.
export const BUSINESS_PROFILE_FALLBACK: D2CSiteBusinessProfile = {
  tradeName: '무지개렌트카',
  registrationNumber: '130-86-50144',
  representative: '변 희 정',
  mailOrderNumber: '제2022-제주도두-0033호',
  address: '제주특별자치도 제주시 제성1길 28-1',
  phone: '064)710-1600',
  email: 'rainbowrentacar@naver.com',
  copyright: 'Copyright © 2015 www.rainbowrent.co.kr All Rights Reserved.',
};

export const CONTACT_PROFILE_FALLBACK: D2CSiteContactProfile = {
  csPhone: '064-710-1600',
  csHours: '매일 (공휴일 제외) 08시~21시',
  breakTime: '12시 30분 ~ 13시 30분',
};

// 홈 첫 화면 이미지·문구, 배너, 팝업. 내용 API가 실패했을 때만 쓴다.
// 문구에서 **로 감싼 부분은 굵게 보인다.
export const HOME_HERO_FALLBACK: D2CSiteImageList = {
  headline: '즐거운 제주도 여행!',
  headlineLine2: '**렌터카 예약**을 도와드릴게요',
  items: [
    {
      id: 'home_main',
      image: '/assets/home/img_rainbow_home_banner_pc.png',
      mobileImage: '/assets/home/img_rainbow_home_banner_mobile.png',
      alt: '무지개렌트카 홈 배너',
      startAt: '',
      endAt: '',
      visible: true,
    },
  ],
};

export const HOME_BANNERS_FALLBACK: D2CSiteImageList = {
  sectionTitle: '무지개 공지사항',
  items: [
    {
      id: 'home_renewal_banner',
      image: '/assets/home/img_banner-temporary.svg',
      mobileImage: '/assets/home/img_banner-mobile-temporary.svg',
      alt: '무지개렌트카 홈 리뉴얼 안내 배너',
      link: '',
      startAt: '',
      endAt: '',
      visible: true,
    },
  ],
};

export const HOME_POPUP_FALLBACK: D2CSiteImageList = { items: [] };
